import { paths } from '@farmersdog/constants';

export function getRecipesRouteForPet(petName: string) {
  return `${paths.PATH_SIGNUP_RECIPES}?pet=${petName}&card=RecipeSelection`;
}
